import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

// Generalized Button Component
const Button = ({ type, label, backgroundColor, textColor, handler, style = {}, form_type, icon, disabled = false }) => {

  const commonStyles = {
    backgroundColor: backgroundColor || "#7DDBFF",
    color: textColor || "#fff",
  };
  const shadow = { boxShadow: "0px 5px 10px 0px rgba(0, 0, 0, 0.5)" };

  const buttonTypes = {
    small: (
      <button
        type="form_type"
        onClick={handler}
        style={{ ...commonStyles, ...style }}
        className="btn-blue-sm active:scale-95"
      >
        {label}
      </button>
    ),
    small_bordered: (
      <button type='form_type' disabled={disabled} onClick={handler} style={{ ...commonStyles, ...style, }}
        className="btn-blue-sm-bordered cursor-pointer ">
        {label}
      </button>
    ),
    full: (
      <button
        type="form_type"
        onClick={handler}
        style={{ ...commonStyles, ...style }}
        className="btn-blue-full "
      >
        {label}
      </button>
    ),
    largeAdd: (
      <button type='form_type' onClick={handler} style={{ ...commonStyles, ...style }} className="btn-blue-lg">
        +
      </button>
    ),
    largeFull: (
      <button
        type="form_type"
        onClick={handler}
        style={{ ...commonStyles, ...style }}
        className="btn-black-lg"
      >
        {label}
      </button>
    ),
    smallAdd: (
      <button
        type="form_type"
        onClick={handler}
        style={{ ...commonStyles, ...style }}
        className="btn-black-sm"
      >
        +
      </button>
    ),
    iconButton: (
      <button 
      type='form_type' 
      onClick={handler} style={{ ...commonStyles, ...style }} className="btn-blue-icon">
   <FontAwesomeIcon icon={icon} />

        {label}
      </button>
    ),
  };

  return (
    buttonTypes[type] || (
      <button
        type="form_type"
        style={{
          ...style,
          ...shadow,
          backgroundColor: backgroundColor || "#f2f2f2",
        }}
        onClick={handler}
        className="py-3 px-4 font-roboto text-sm tracking-wider  rounded"
      >
        {label}
      </button>
    )
  );
};

export default Button;
